export default __webpack_public_path__ + "static/media/sensitivity-var.65a469ec.svg";